export function lazyObserve(targets, callback, options = {}) {
  const getElementsFromTargets = input => {
    if (!input) return [];
    if (typeof input === 'string') {
      // Se a string contém '/', é um caminho de arquivo - extrair nome do custom element
      if (input.includes('/')) {
        const parts = input.split('/');
        const customElementName = parts[parts.length - 1]; // Último índice é o nome do custom element
        return Array.from(document.querySelectorAll(customElementName));
      }
      // Caso contrário, tratar como seletor CSS normal
      return Array.from(document.querySelectorAll(input));
    }
    if (input instanceof Element) return [input];
    if (input instanceof NodeList || Array.isArray(input))
      return Array.from(input).filter(n => n instanceof Element);
    return [];
  };

  const elementsToObserve = getElementsFromTargets(targets);
  if (elementsToObserve.length === 0) return;

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(async entry => {
      if (entry.isIntersecting) {
        obs.unobserve(entry.target);

        // Verifica se há atributo data-animate e adiciona a classe
        const animate = entry.target.dataset.animate;
        if (animate) {
          entry.target.classList.add(`animate-${animate}`);
        }

        // Verifica se há atributo data-style e faz preload
        const cssHref = entry.target.dataset.style;
        if (cssHref && !document.querySelector(`link[href="${cssHref}"]`)) {
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = cssHref;
          document.head.appendChild(link);

          // Aguarda carregamento do CSS antes de executar callback
          await new Promise(resolve => {
            link.onload = resolve;
            link.onerror = resolve; // em caso de erro, não trava
          });
        }

        // Executa o callback (ex: import do módulo)
        callback(entry.target);
      }
    });
  }, options);

  elementsToObserve.forEach(el => {
    observer.observe(el);
  });
}
